import hubConnector from "@/hubs/hubConnector";

export default {
  getConnection() {
    return hubConnector.getHubConnection("api-notification", "backgroundJobHub");
  }
}
